export default "__VITE_ASSET__Hp4pfOcv__"